// ToggleCard.tsx
import { Add } from '@mui/icons-material';
import React from 'react';

interface ToggleCardProps {
  position:
    | 'top-left'
    | 'top-right'
    | 'bottom-left'
    | 'bottom-right'
    | 'top-left-1'
    | 'top-right-1'
    | 'bottom-left-1'
    | 'bottom-right-1'
    | 'top'
    | 'right'
    | 'bottom'
    | 'left'
    | 'commonPosition_1'
    | 'commonPosition_2'
    | 'commonPosition_3'
    | 'commonPosition_4';
  isOpen: boolean;
  onToggle: (position: string) => void;
  cardContent: React.ReactNode; // This prop will accept the content for the card
}

export const ToggleCard: React.FC<ToggleCardProps> = ({
  position,
  isOpen,
  onToggle,
  cardContent,
}) => {
  const toggleDropdown = () => {
    onToggle(position);
  };

  const getCardPositionStyle = () => {
    switch (position) {
      case 'top-left':
        return { top: 0, left: 0 };
      case 'top-right':
        return { top: 0, right: 0 };
      case 'bottom-left':
        return { bottom: 0, left: 0 };
      case 'bottom-right':
        return { bottom: 0, right: 0 };
      case 'top-left-1':
        return { top: '2.5rem', left: '50%', transform: 'translateX(-50%)' };
      case 'top-right-1':
        return { top: 0, right: 0 };
      case 'bottom-left-1':
        return { bottom: 0, left: 0 };
      case 'bottom-right-1':
        return { bottom: '2.5rem', left: '50%', transform: 'translateX(-80%)' };
      case 'bottom':
        return { bottom: '2.5rem', left: '50%', transform: 'translateX(-50%)' };
      case 'top':
        return { top: '2.5rem', left: '50%', transform: 'translateX(-50%)' };
      case 'right':
        return { bottom: 0, right: 0 };
      case 'left':
        return { bottom: -100, left: 10 };
      case 'commonPosition_1':
        return { bottom: 0, right: 0 };
      case 'commonPosition_2':
        return { bottom: 0, right: 0 };
      case 'commonPosition_3':
        return { bottom: 0, right: 0 };
      case 'commonPosition_4':
        return { bottom: 0, right: 0 };

      default:
        return {};
    }
  };

  return (
    <div className="toggle-card-container">
      <button
        className="bg-purple-600 h-8 w-8 rounded-full text-white flex items-center justify-center cursor-pointer hover:bg-purple-800"
        onClick={toggleDropdown}
      >
        <Add />
      </button>
      {isOpen && (
        <div className="card z-10" style={getCardPositionStyle()}>
          {/* Display the provided card content */}
          {cardContent}
        </div>
      )}
    </div>
  );
};
